export enum VideoDownloadStateEnum {
    notDownloaded = 0,
    requiresDownloading = 1,
    downloading = 2,
    downloaded = 3,
    corruption = 4,
    paused = 5,
    cancelled = 6,
}
